// Panelin geçmiş ekranlarında (finans işlemleri, casino turları, spor
// kuponları) ortak tarih süzgeci. Seçenekler ve istek parametreleri tek
// yerdedir; anahtarlar backend'deki ``DATE_RANGES`` kümesiyle aynı olmalıdır
// (backend/routers/admin_router.py), ayrışırsa uç 400 döner.
//
// Hazır aralıklar **sunucuda** hesaplanır: istemci saati yanlış kurulmuşsa
// liste sessizce kaymamalıdır. Serbest aralıkta gün sınırları Türkiye gününe
// göre çevrilir ve **bitiş günü dahildir**.

export const DATE_RANGE_OPTIONS = [
  { id: 'all', label: 'Tüm zamanlar' },
  // Takvim günü (Türkiye saati, 00:00–23:59); "24 Saat" şu andan geriye sayar.
  { id: 'today', label: 'Bugün' },
  { id: 'yesterday', label: 'Dün' },
  { id: '1d', label: '24 Saat' },
  { id: '7d', label: '1 Hafta' },
  { id: '30d', label: '1 Ay' },
  { id: 'custom', label: 'Tarih seç' },
];

export const EMPTY_DATE_RANGE = {
  range: 'all', from: '', to: '', fromTime: '', toTime: '',
};

// Bugünün yerel tarihi (YYYY-AA-GG). Tarih girişlerinde üst sınır olarak
// kullanılır: gelecekteki bir gün hiçbir kaydı getirmez, seçtirmenin anlamı
// yok. ``toISOString`` UTC'ye çevirdiği için gece yarısı civarında bir gün
// geriye kayardı; parçalar yerel saatten okunur.
export const todayInputValue = (now = new Date()) => [
  now.getFullYear(),
  String(now.getMonth() + 1).padStart(2, '0'),
  String(now.getDate()).padStart(2, '0'),
].join('-');

const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/;

/** Tarihe (varsa) saati ekler: `2026-09-25` + `14:30` → `2026-09-25T14:30`. */
const withTime = (date, time) => (
  date && TIME_RE.test(time || '') ? `${date}T${time}` : date
);

/** Süzgeç durumundan istek parametrelerini üretir.
 *
 * Serbest aralık saat de taşıyabilir (`fromTime` / `toTime`, Türkiye saati).
 * Tek günlük saat aralığı için yalnızca başlangıç tarihi yeterlidir: bitiş
 * saati girilip bitiş tarihi boş bırakılırsa aynı gün sayılır (ve tersi).
 */
export const dateRangeParams = (value) => {
  const {
    range, from, to, fromTime, toTime,
  } = { ...EMPTY_DATE_RANGE, ...(value || {}) };
  if (!range || range === 'all') return {};
  if (range !== 'custom') return { range };
  const fromDate = from || (fromTime && to) || '';
  const toDate = to || (toTime && from) || '';
  // Serbest aralık seçilip tarih girilmemişse süzgeç yok sayılır; boş bir
  // pencere göndermek listeyi sebepsiz boşaltırdı.
  if (!fromDate && !toDate) return {};
  const params = { range: 'custom' };
  if (fromDate) params.date_from = withTime(fromDate, fromTime);
  if (toDate) params.date_to = withTime(toDate, toTime);
  return params;
};

/** Süzgeç gerçekten bir pencere daraltıyor mu (boş "tarih seç" hariç). */
export const isDateRangeActive = (value) => (
  Object.keys(dateRangeParams(value)).length > 0
);
